import { render, staticRenderFns } from "./DocumentCustomerSidebar.vue?vue&type=template&id=6af5811b&scoped=true"
import script from "./DocumentCustomerSidebar.vue?vue&type=script&lang=js"
export * from "./DocumentCustomerSidebar.vue?vue&type=script&lang=js"
import style0 from "./DocumentCustomerSidebar.vue?vue&type=style&index=0&id=6af5811b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5811b",
  null
  
)

export default component.exports